module.exports = __webpack_public_path__ + "static/splash_overlay_mobile-c1dee92c86e60b0507c20b929384e1f0.png";